import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

const buildUpsertBenefitOptionOfPolicy = function(errorHandler) {
	return async function({ policyId, endorsementId, input, store }) {
		const query = gql`
			mutation upsertBenefitOptionOfPolicy(
				$policyId: String!
				$endorsementId: String
				$input: benefitOptionInput!
			) {
				upsertBenefitOptionOfPolicy(
					policyId: $policyId
					endorsementId: $endorsementId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, input }

		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.upsertBenefitOptionOfPolicy, store)
		return {
			status: res?.data?.upsertBenefitOptionOfPolicy?.status,
			id: res?.data?.upsertBenefitOptionOfPolicy?.createdStatus?.id
		}
	}
}

const buildRemoveBenefitOptionFromPolicy = function(errorHandler) {
	return async function({ policyId, endorsementId, typeId, store }) {
		const query = gql`
			mutation removeBenefitOptionFromPolicy(
				$policyId: String!
				$endorsementId: String = null
				$typeId: String!
			) {
				removeBenefitOptionFromPolicy(
					policyId: $policyId
					endorsementId: $endorsementId
					typeId: $typeId
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, typeId }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.removeBenefitOptionFromPolicy, store)
		return {
			status: res?.data?.removeBenefitOptionFromPolicy?.status,
			id: res?.data?.removeBenefitOptionFromPolicy?.createdStatus?.id
		}
	}
}

export { buildUpsertBenefitOptionOfPolicy, buildRemoveBenefitOptionFromPolicy }
